module.exports = __webpack_public_path__ + "media/images/emblems/Eichberg-coat_of_arms-73fea6b5b7681c1709b21cc06d789e47.svg";